
import React from 'react'
import { Box, Typography, TextField, MenuItem, Select, Button, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import legolasApi from '../../api/legolas'

const booleanOptions = [
  {
    value: 1,
    label: 'Yes',

   },
  {
    value: 0,
    label: 'No',

   }
  
];

function NewRma(props) {
 
  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }
 

  const [allowCustomerCreateRma, setAllowCustomerCreateRma] = React.useState('');
  const [defaultRmaManager, setDefaultRmaManager] = React.useState('');
  const [agreeReturnPolicy, setAgreeReturnPolicy] = React.useState('');
  const [adminUsers, setAdminUsers] = React.useState([])
  const [configPath, setConfigPath] = React.useState('rma/createNew/');
  const [changedData, setChangedData] = React.useState([]);
  const [alertText, setAlertText] = React.useState('')
  const [openAlert, setOpenAlert] = React.useState(false)
  const payloadData = [];
  // const changedData = [];

  React.useEffect(() => {
    axios.get(`${legolasApi.url}/admin/config/get/all`).then((res) => {
      console.log("Order data1",res.data);
      if (res.data.success) {
        res.data.data.map((singleConfig) => {
          switch(singleConfig.path) {
            case 'rma/createNew/allow_customer_create_rma':
              setAllowCustomerCreateRma(singleConfig.value);
              break;
            case 'rma/createNew/default_rma_manager':
              setDefaultRmaManager(singleConfig.value);
              break;
            case 'rma/createNew/agree_return_policy':
              setAgreeReturnPolicy(singleConfig.value);
              break;
            default:
              break;
          }

        });
      }
    })
    axios.get(`${legolasApi.url}/admin/rma/manager/list`).then(res => {
      console.log("Admin Users:", res.data);
      const usersData = res.data.data.rows;
      if(usersData) {
        setAdminUsers(usersData)
      } else {
        setAdminUsers([])
      }
      
    })
  }, [])


  const handleConfigChange = (key, value) => {

    let allowCustomerCreateRmaData = {
      key:'allow_customer_create_rma',
      value: allowCustomerCreateRma
    }
    let defaultRmaManagerData = {
      key:'default_rma_manager',
      value: defaultRmaManager
    }
    let agreeReturnPolicyData = {
      key:'agree_return_policy',
      value: agreeReturnPolicy
    }
    // changedData.push(pair);
    
    switch(key) {
      case 'allow_customer_create_rma':
        setAllowCustomerCreateRma(value);
        allowCustomerCreateRmaData = {
          key:'allow_customer_create_rma',
          value: value
        }
        break;
      case 'default_rma_manager':
        setDefaultRmaManager(value);
        defaultRmaManagerData = {
          key:'default_rma_manager',
          value: value
        }
        break;
      case 'agree_return_policy':
        setAgreeReturnPolicy(value);
        agreeReturnPolicyData = {
          key:'agree_return_policy',
          value: value
        }
        break;
      default:
        break;
    }
    setChangedData([allowCustomerCreateRmaData, defaultRmaManagerData, agreeReturnPolicyData])
    // console.log("changedData: ",changedData);
  }

  
  function handleSubmitConfig() {
    // console.log("calling handleSubmitConfig", changedData);
    changedData.map((data) => {
      // console.log("final data",data);
      let record = {
        scope: 'default',
        scope_id: 0,
        path: configPath + data.key,
        value: data.value
      }
      payloadData.push(record);
    });
    axios.post(`${legolasApi.url}/admin/config/add`, payloadData).then((res) => {
      // console.log('Save config res: ', res)
      const data = res.data
      if (data.success) {
        handleAlertGen(data.message)
      }
    }).catch((error) => {
      console.log('Error in submit res: ', error)
    })
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }
 
  return (
    <React.Fragment>
      
      <Box id='accountinfo-box'>
        <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
            {alertText}
          </Alert>
        </Snackbar>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
          Create New RMA Options
          </Typography>
        </Box>
      
        <Box component="form"
          sx={{
            '& .MuiTextField-root': { m: -1,     width: '355px','padding-right': '0.5rem','padding-top':'10px' },
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <Box sx={lightBox} >
                        <Typography> Allow Customers To Create RMA On Storefront</Typography>
            <TextField
              id="outlined-select-currency-native"
              select
              name='allow_customer_create_rma'
              value={allowCustomerCreateRma}
              onChange={(e) => handleConfigChange('allow_customer_create_rma', e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              {booleanOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
            </Box>
          </div>
          <Box sx={lightBox}>
            <Typography>Default Manager For New RMA</Typography>
            <Select 
              //value={shippingPartnerId} 
              label='Select Shipping Partner'
              name='default_rma_manager'
              onChange={(e) => handleConfigChange('default_rma_manager', e.target.value)}
              value={defaultRmaManager}
              sx={{ width: '355px', height: '40px', borderRadius: '0px', border: '1px solid #000' }}
              //disabled={true}
            >
              {
                adminUsers.map(user => {
                  return (
                    <MenuItem value={user.user_id}>{user.firstname + ' ' + user.lastname}</MenuItem>
                  )
                })
              }
            </Select>
          </Box>
          <div>
            <Box sx={lightBox} >
              <Typography> Require to Agree to Return Policy</Typography>
              <TextField
                id="outlined-select-currency-native"
                select
                name='agree_return_policy'
                value={agreeReturnPolicy}
                onChange={(e) => handleConfigChange('agree_return_policy', e.target.value)}
                SelectProps={{
                  native: true,
                }}
              >
                {booleanOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Box>
          </div>
        </Box>   
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey, margin: '15px 0px' }}>
        <Button sx={globalStyles.reusableButton} onClick={() => handleSubmitConfig()}>Save  </Button>
      </Box>
    </React.Fragment>
  )
}
 export default NewRma